import React from 'react';
import './src/css/style.css';
import 'video-react/dist/video-react.css';

import {PageLayout} from './src/layouts/page-layout'

import 'react-phone-input-2/lib/material.css'

export const wrapPageElement = ({ element, props }) => {
  return <PageLayout {...props}>{element}</PageLayout>;
};
